let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("imD7j")).then(() => parcelRequire('hWO8P'));